// Firebase Configuration for QuickRoll Web App
// This file initializes Firebase Analytics for tracking user behavior

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Firebase configuration - same project as Android/iOS apps
const firebaseConfig = {
    apiKey: "AIzaSyB644iZJuOpHeJ1SEHxJkEG-M_QpJDqUCY",
    authDomain: "quickrollplayintegrity.firebaseapp.com",
    projectId: "quickrollplayintegrity",
    storageBucket: "quickrollplayintegrity.firebasestorage.app",
    messagingSenderId: "398355783352",
    appId: "1:398355783352:web:2fb7486019dd5981a2de4d",
    measurementId: "G-CF93XS76RK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
let analytics = null;
if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
}

export { app, analytics };
